/**
 * Upload scanned letter event for Protocol Management
 */
(function () {
    'use strict';

    //fire funcs when ready
    ready(uploadAdhLetterEvent);

    /**
     * Detect if doc is ready and fire func inside
     *
     * @param fn
     */
    function ready(fn) {
        if (document.attachEvent
                ? document.readyState === 'complete'
                : document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    /**
     * Click event for uploading scanned letter
     */
    function uploadAdhLetterEvent() {
        var uploadInputs = document.querySelectorAll('input.upload-scan-letter'),
            i;

        if (uploadInputs === null) {
            return;
        }

        for (i = 0; i < uploadInputs.length; ++i) {
            uploadInputs[i].addEventListener('change', function (e) {
                e.preventDefault();
                uploadAdhLetter(e, this.getAttribute('data-adh-id'));
            });
        }
    }

    function sendLetterId(adherenceId, letterUrl ) {
        jQuery.ajax({
            url: wpAjaxJSONpVars.ajaxurl,
            method: 'POST',
            data: {
                nonce: wpAjaxJSONpVars.wpAJAXNonce,
                action: 'protocolSubmitLetter',
                adherenceId: adherenceId,
                letterUrl: letterUrl
            }
        }).success(function (response) {
            if (response) {
                window.location.reload();
            } else {
                $('#upload-scan-response-' + adherenceID).removeClass()
                    .addClass('alert alert-danger')
                    .text('Upload Failed');
            }
        }).error(function (response) {
            $('#upload-scan-response-' + adherenceID).removeClass()
                .addClass('alert alert-danger')
                .text('Upload Failed');
        });
    }

    /**
     * Upload click event triggers media library
     *
     * @param $adhId
     */
    function uploadAdhLetter(e, adherenceID) {
        if ('undefined' === typeof( jQuery('#upload-scan-' + adherenceID)[0].files[0]
            )) {
            alert('Select a file!');
            return;
        }

        var blnValid = false;
        var fileName = jQuery('#upload-scan-' + adherenceID).val()
            .split('\\')
            .pop();
        var validFileExtensions = ['.pdf'];

        for (var j = 0; j < validFileExtensions.length; j++) {
            var sCurExtension = validFileExtensions[j];
            if (fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length)
                    .toLowerCase() == sCurExtension.toLowerCase()) {
                blnValid = true;
                break;
            }
        }

        if (!blnValid) {

            $('#upload-scan-response-' + adherenceID)
                .addClass('alert alert-danger')
                .text('Sorry, ' + fileName + ' is invalid, allowed extensions are: ' + validFileExtensions.join(', '));
            return false;
        }

        // Grab the file from the input.
        var file = jQuery('#upload-scan-' + adherenceID)[0].files[0];

        var formData = new FormData();
        formData.append('file', file);
        formData.append('folder', 'protocol-adherence');

        // Fire the request.
        jQuery.ajax({
            //url        : wpApiSettings.root + 'wp/v2/media?front_upload',
            url: wpApiSettings.root + 'isda/v1/files',
            method: 'POST',
            fileType:1,
            folder:'protocol-adherence',
            processData: false,
            contentType: false,
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
            },
            data: formData
        }).success(function (response) {
            if ('undefined' !== typeof response.url && response.url != '' ) {
                sendLetterId(adherenceID, response.url);
            }
        }).error(function (response) {
            //            console.log('Failed ajax');
            //            console.log(response);
            $('#upload-scan-response-' + adherenceID).removeClass()
                .addClass('alert alert-danger')
                .text('Upload Failed');
        });

    }
})();